/**
 * Resolve the API path addressing one org member.
 *
 * Invite-flow members are addressed by their invite record. SSO-provisioned
 * members have no invite record, so they are addressed by email. The invite
 * arm is kept for deploy-skew safety while backends without the by-email
 * endpoints are still around; once those are deployed everywhere, both kinds
 * can be addressed by email and the invite branch here can be deleted.
 */
export const memberEndpoint = (
  orgId: string | undefined,
  { inviteId, email }: { inviteId?: string; email: string },
): string =>
  inviteId
    ? `/org-members/${orgId}/invites/${inviteId}`
    : `/org-members/${orgId}/members/${encodeURIComponent(email)}`;
